import React, { useEffect, useState } from "react";
import { Text, Col, } from "components";
import { LoginForm } from "containers";
import { login, userChangeOperationStates } from "store/modules";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Logo from "assets/images/logo.png";

import {
    ContentLogin,
    ContainerForm,
    BottomTextContainer,
} from "./style";
import { localizedStrings } from "constants/localizedStrings";
import { Row } from "reactstrap";

export default function DriverLogin({ history }) {

    const { register, setValue, handleSubmit, getValues } = useForm({
        defaultValues: {
            email: "",
            password: "",
        }
    });

    const dispatch = useDispatch();

    const {
        loginFail
    } = useSelector(state => state.auth);


    const [errors, setErrors] = useState({
        identification: {
            error: false,
            message: localizedStrings.errors.fieldRequired
        },
        password: {
            error: false,
            message: localizedStrings.errors.fieldRequired
        },
        emailPasswordWrong: {
            error: false,
            message: localizedStrings.errors.emailPasswordWrong
        }
    });
    const [fieldsToValidate,] = useState([
        "identification",
        "password",
    ]);

    const showError = (field, message = localizedStrings.errors.fieldRequired) => {
        if (!errors[field]) return;
        errors[field].message = message;
        errors[field].error = true;
    }
    const clearError = field => {
        if (!errors[field]) return;
        errors[field].message = "";
        errors[field].error = false;
    }

    function handleError({
        fields
    }) {
        let hasError = false;
        try {
            fields.forEach(field => {
                const fieldValue = getValues()?.[field] ?? "";

                const hasValue = fieldValue.toString().trim();

                hasValue
                    ? clearError(field)
                    : showError(field)
                hasError += !hasValue
            })

            setErrors({ ...errors });
        } catch (error) {
            console.log(error);
        }
        return !!hasError
    }


    useEffect(() => {
        if (loginFail) {
            errors.emailPasswordWrong.error = true;
            setErrors({ ...errors });
        }
        // eslint-disable-next-line
    }, [loginFail]);

    useEffect(() => {

        dispatch(userChangeOperationStates({}));
        // eslint-disable-next-line
    }, []);

    function handleLogin() {
        const hasError = handleError({ fields: fieldsToValidate });

        if (!hasError) dispatch(login({
            ...getValues(),
        }));
    }

    return (
        <ContentLogin>
            <div>
                <Row style={{
                    margin: "0px"
                }}>
                    <Col xl="12" xxl="12" style={{
                        margin: "0px"
                    }}>
                        <ContainerForm>
                            <div>
                                <img src={Logo} alt="company logo" />
                                <LoginForm
                                    onSubmit={handleSubmit(handleLogin)}
                                    errors={errors}
                                    inputsConfig={{
                                        onChange: setValue,
                                        register,
                                        getValues,
                                    }}
                                />
                            </div>
                        </ContainerForm>
                    </Col>
                </Row>
            </div>
            <BottomTextContainer>
                <Text
                    color="#868E96"
                    fontSize="14px"
                >
                    {localizedStrings.login.developedByFullText}
                    {new Date().getFullYear()}
                </Text>
            </BottomTextContainer>
        </ContentLogin>
    );
}
